import {ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input, Optional, Provider} from '@angular/core';
import {FormGroupDirective, NG_VALUE_ACCESSOR} from '@angular/forms';
import {INgClass, PersistentInputComponent} from '@ideals/types';
import {RadioButtons} from './models/types';

export const IDEALS_RADIO_BUTTON_CONTROL_VALUE_ACCESSOR: Provider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => RadioButtonsComponent),
  multi: true
};

@Component({
  selector: 'ideals-radio-buttons',
  templateUrl: './radio-buttons.component.html',
  styleUrls: ['./radio-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [IDEALS_RADIO_BUTTON_CONTROL_VALUE_ACCESSOR]
})
export class RadioButtonsComponent extends PersistentInputComponent {
  @Input()
  public isTabs: boolean;

  @Input()
  public radioButtons: RadioButtons = [];

  constructor(
    @Optional()
    public readonly parentFormGroup: FormGroupDirective,
    private readonly _changeDetectorRef: ChangeDetectorRef,
  ) {
    super(parentFormGroup, _changeDetectorRef);
  }

  public getChecked(value: number): boolean {
    return value === this.value;
  }

  public getRadioButtonClasses(value: number, last: boolean): INgClass {
    return {
      active: this.getChecked(value),
      disabled: this.disabled,
      'radio-tab': this.isTabs,
      'radio-tab-last': this.isTabs && last,
    };
  }
}
